import type { ProductDraft } from "@/lib/catalog/types";

const WIZARD_KEY = "inventory.addProductWizard.v1";

export type AddProductWizardSnapshot = {
  step: number;
  draft: ProductDraft;
  /** Product id in catalog store after first successful "Save & Next". */
  persistedProductId?: string | null;
};

export function loadAddProductWizard(): AddProductWizardSnapshot | null {
  if (typeof sessionStorage === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(WIZARD_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as AddProductWizardSnapshot;
    if (typeof parsed.step !== "number" || !parsed.draft || typeof parsed.draft !== "object") return null;
    if (
      parsed.persistedProductId != null &&
      typeof parsed.persistedProductId !== "string"
    )
      return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveAddProductWizard(snapshot: AddProductWizardSnapshot): void {
  if (typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.setItem(WIZARD_KEY, JSON.stringify(snapshot));
  } catch {
    /* quota or private mode */
  }
}

export function clearAddProductWizard(): void {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.removeItem(WIZARD_KEY);
}
